<template>
    <!-- 设备实时轨迹 -->
    <div id="channelPopup" class="channelPopup">
        <p class="gispopup-titlePoint" :title="this.point.name">{{ this.point.name }}</p>
        <i :title="$t('pgCommon.VIDEO')" class="el-icon-video-play gispopup-deletePint" style="font-size:25px;" @click="palyVideo()"></i>
        <i :title="$t('common.CANCAL')" @click="closePopup()" style="font-size:25px;" class="el-icon-close channelPopup-elclose"></i>
        <el-form label-width="80px">
            <el-form-item :label="$t('pgCommon.GROUND_SPEED')">{{ this.feature.data.speed }}</el-form-item>
            <el-form-item :label="$t('pgCommon.LONGITUDE')">{{ this.feature.geometry[0] }}</el-form-item>
            <el-form-item :label="$t('pgCommon.LATITUDE')">{{ this.feature.geometry[1] }}</el-form-item>
        </el-form>
    </div>
</template>
<script>
import api from '../assets/api.js';
export default {
    props: {
        clickCallback: null, //回调函数
        feature: null //点中的图标元素
    },
    data() {
        return {
            point: {
                name: null //名称
            }
        };
    },
    created() {
        console.log('this.feature', this.feature);
        if (this.feature.data && this.feature.data.caption) {
            this.point.name = this.feature.data.caption;
        }
    },
    methods: {
        /**
         * 关闭地图弹出窗口
         */
        closePopup() {
            this.clickCallback({ data: this.feature });
        },
        /**
         * 预览
         */
        palyVideo() {
            if (this.feature && this.feature.data && this.feature.data.resourceId) {
                api.queryDeviceInfo({ iDeviceType: window.pangu.common.devType.DEVICE_CODING_TYPE, sDeviceIds: [this.feature.data.resourceId] }, response => {
                    if (response.status == 200) {
                        if (response.data.statusCode == 'API-COMMON-INF-OK') {
                            let sIds = response.data.content.map(e => {
                                return e.sId;
                            });
                            api.queryDeviceInfo({ iDeviceType: window.pangu.common.devType.DEVICE_CAMERA_TYPE, sParentIds: sIds }, response => {
                                if (response.status == 200) {
                                    if (response.data.statusCode == 'API-COMMON-INF-OK') {
                                        let chIds = response.data.content.map(e => {
                                            return e.sId;
                                        });
                                        let params = {
                                            agentId: JSON.parse(sessionStorage.getItem('socketInfo')).agentId,
                                            platform:
                                                window.location.protocol +
                                                '//' +
                                                window.location.hostname +
                                                (window.location.port ? ':' + window.location.port : '') +
                                                '/' +
                                                JSON.parse(sessionStorage.getItem('socketInfo')).platform,
                                            token: sessionStorage.getItem('token'),
                                            sender: 'platformClient',
                                            cmd: 101,
                                            clientlist: ['GisClient'],
                                            param: {
                                                platIp: window.config.host.split('/')[2].split(':')[0],
                                                platPort: parseInt(window.config.host.split('/')[2].split(':')[1]),
                                                id: chIds,
                                                rtsp: '',
                                                username: sessionStorage.username,
                                                userid: sessionStorage.userId,
                                                token: sessionStorage.getItem('token'),
                                                exeTitle: '平台播放器',
                                                lang: 'CN',
                                                skin: window.vue.$store.state.skin,
                                                layout: 'layoutGisVideo',
                                                userLevel: parseInt(sessionStorage.getItem('userLevel')),
                                                menu: [3, 5, 16]
                                            }
                                        };
                                        console.info('params', params);
                                        window.vue.$socketApi.send(params.agentId, params, this.playVideoCallBack);
                                    }
                                }
                            });
                        }
                    }
                });
            } else {
                this.$message({
                    showClose: true,
                    message: this.$t('pgError.ERROR_RESOURCE_ID_NULL'),
                    type: 'error'
                });
            }
        },
        playVideoCallBack(e) {
            if (!e.param.ret == 0) {
                this.$message({
                    showClose: true,
                    message: this.$t('pgError.ERROR_EXE_START_FAIL'),
                    type: 'error'
                });
            }
            console.info('playVideoCallBack', e);
        }
    }
};
</script>
